import { render } from "./PowerupListItem.vue?vue&type=template&id=db31e3a0&scoped=true"
import script from "./PowerupListItem.vue?vue&type=script&lang=js"
export * from "./PowerupListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db31e3a0"]])

export default __exports__